export default "__VITE_ASSET__D2OQJg1z__"